export default __webpack_public_path__ + "46a62a2a67edbed73ac72501ceabffef.png";